import React, { useState } from "react";
import "../../index.css";
import Customer from "../../assets/termsandconditions/Customer.svg";
import Retailer from "../../assets/termsandconditions/Retailer.svg";
import Star from "../../assets/termsandconditions/star.svg";
import DropDown from "../../assets/termsandconditions/dropdown.svg";
import DropUp from "../../assets/termsandconditions/dropup.svg";

const PrivacyAndPolicyBusiness = () => {
    const [customerCard, setCustomerCard] = useState(false);
    const [vendorCard, setVendorCard] = useState(false);

    return (
        <div className="max-sm:px-[30px] max-lg:px-[50px] lg:mx-[120px] pt-[100px] md:pt-[120px] overflow-x-hidden">
            <div>
                <h1 className="text-[28px]  text-[#2E2C43] poppins-black  max-sm:text-[26px]">
                   *Privacy & Policy
                </h1>
            </div>
            <div className="w-full flex flex-col gap-[40px] mt-[30px] mb-[30px] md:mt-[30px]  ">

                <div className="mb-[30px] flex ">
                    <div className="w-[100%] sm:p-[20px] flex flex-col gap-4 mx-auto">

                        <div className="relative pb-[40px]">
                            <p className="text-[20px] poppins-extrabold text-[#2E2C43]">
                                CulturTap Genie Business
                            </p>
                            <ul className="flex flex-col mt-[20px]">
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            Personal Information We Collect:
                                            We collect the following personal information to provide you with the best service: Name, Mobile Number, Store Name, Store Images, Store Location, Store Description, Store Category, and GST/Labor Certificate.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Use of Personal Data:
                                        We collect your personal data to create and manage your account, process orders and invoices, identify you on our platform, and contact you to respond to any queries or concerns.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            Document Use:
                                            Documents are used to verify authentic vendors and confirm store locations, ensuring a seamless and reliable experience for our customers.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Data Privacy:
                                        We do not share your data with anyone outside the CulturTap community. We prioritize vendor data privacy. Customers will not receive any vendor details directly; contact information will only be shared once the deal is closed.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]  poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                App Permissions:{" "}
                                            </span>
                                            Notifications, Camera, Gallery, Storage, Location.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  pl-[25px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]  poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Notifications:{" "}
                                            </span>
                                            Required to receive app notifications for updates and offers.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  pl-[25px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Camera:{" "}
                                            </span>
                                            Needed to capture store images when registering a new account, updating your profile, and sending attachments or offers during bargaining.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  pl-[25px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Gallery:{" "}
                                            </span>
                                            Required to upload and save product and store images in your gallery.                             
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  pl-[25px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Storage:{" "}
                                            </span>
                                            Needed to store images and documents within the app.
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]  pl-[25px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        {/* <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        /> */}
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            <span className="text-[14px]  poppins-bold text-[#001B33]">
                                                - Location:{" "}
                                            </span>
                                            Required to collect the vendor’s store location and provide location references to customers
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                            Data Sharing:
                                            We have separate apps to target customers (demand) and vendors (supply). Data is shared securely between these apps, and only with the user's consent. We do not sell any data to third parties. All necessary permissions are requested during the launch of the application to ensure a smooth and secure experience.         
                                        </p>
                                    </div>
                                </li>
                                <li className="text-[14px]   poppins-regular text-[#001B33]">
                                    <div className="flex items-start">
                                        <img
                                            src={Star}
                                            alt="contact"
                                            loading='lazy'
                                            className="w-[10px] h-[10px] mt-[5px] mr-4"
                                        />
                                        <p className="text-[14px]   poppins-regular text-[#001B33]">
                                        Account Deletion & Support:
                                        If you wish to delete your account, simply go to the "Need any help?" section in the app menu. You can raise a request for account deletion, and we will process it promptly. We’re also here to assist you with any other questions or issues you may have!
                                        </p>
                                    </div>
                                </li>
                            </ul>


                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivacyAndPolicyBusiness;
